export default {
	"add0f240cbd4914fd1aed8305872a3f4": "商品价格",
	"842adf4dcc244345b0c757e41a063bd5": "签约优惠",
	"0c7bd83e46479eb03047f35d4a76284b": "签约价",
	"7494bddf5fbef99f30017752738b0f71": "您已进行内容体验，支付解锁全量内容"
}
